<template>
  <DocExport v-if="article" :doc="article" />
  <Layout v-else-if="isError" :show-upgrade-prompt-modal="false">
    <div class="layout__wrapper">
      <LoadingError />
    </div>
  </Layout>
  <Layout v-else :show-upgrade-prompt-modal="false">
    <div class="layout__wrapper">
      <loading-spinner />
    </div>
  </Layout>
</template>

<script setup lang="ts">
import { onBeforeMount, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { backend } from '@/services/backend'
import { Sentry } from '@/services/sentry'

import { ArticleView } from '@/models/doc.article'
import DocExport from '@/app/components/doc/DocExport.vue'
import Layout from '@/app/components/Layout.vue'
import LoadingError from '@/components/ui/LoadingError.vue'

const route = useRoute()
const router = useRouter()

const article = ref<ArticleView>()
const isError = ref(false)

onBeforeMount(async () => {
  const urlSlug = route.params.url_slug as string
  try {
    const docData = await backend.getArticle(urlSlug)
    const userData = await backend.getDocUserData(docData.id)
    article.value = new ArticleView(docData, userData)
  } catch (error: any) {
    if (error.request && error.request.status === 404) {
      router.push({ name: 'not_found' })
    } else {
      isError.value = true
      Sentry.captureException(error)
    }
  }
})
</script>
